import React from 'react'

export default function Heading() {
    return (
        <>

          <div className="heading">

<h1>

    SPG
</h1>

          </div>  
        </>
    )
}
